import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    countDown: number = 5;
    timer: any = null;
    info: {
        adminActived: string;
        companyId: string;
        companyName: string;
        contactName: string;
        contactPhone: string;
        email: string;
        taxId: string;
        domain: string;
        location: {
            address: string;
            city: string; 
            country: string; 
            state: string;
        };
        address: string;
        city: string;
        country: string;
        state: string;
    } = {
        adminActived: undefined,
        companyId: undefined,
        companyName: undefined,
        contactName: undefined,
        contactPhone: undefined,
        email: undefined,
        taxId: undefined,
        domain: undefined,
        location: {
            address: undefined, 
            city: undefined,
            country: undefined,
            state: undefined,
        },
        address: undefined, 
        city: undefined, 
        country: undefined, 
        state: undefined,  
    };
    ispwdOpen: boolean = false;
    isAgree: boolean = false;
    countryList: {
        code: string;
        name: string;
    }[] = [];
    isChina = true;
    provinceList: {
        code: string;
        countryCode: string;
        name: string;
     }[] = [];
     cityList: {
        code: string;
        name: string;
        stateCode: string;
    }[] = [];
    cityName: string = undefined;
    ticket: string = undefined;
}


// WEBPACK FOOTER //
// ./src/display/apps/CompanyRegister/Modules.State.ts